<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="12">
        <div style="color: #fccc66; line-height: 30px">企业数量和质量</div>
        <entity-mode-ratio></entity-mode-ratio>
      </el-col>
      <el-col :span="11">
        <certification-zone></certification-zone>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="24">
        <div style="color: #fccc66; line-height: 30px">投入品使用量 <span style="font-size:12px">(元/亩)</span> </div>
        <inputs-zone></inputs-zone>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="24">
        <div style="color: #fccc66; line-height: 30px">
          质量安全检测 <span style="color: #f33666">182833</span> 次，
          食用农产品合格证 <span style="color: #f33666">103247</span> 枚
        </div>
        <span style="color: #9cd9fc; font-size: 14px">
          通过完善基于长丰草莓质量安全信息服务通道，搭建政府监管、企业自律和消费者监督的信息共享和交互平台，建立“产品有标准、生产有规程、质量有追溯、市场有监管、企业有诚信”的长效监管模式，提升政府对长丰草莓质量安全的监管效能，增强长丰草莓生产经营者的信息化管理水平和质量管控能力，为长丰县草莓产业化发展和优质草莓品牌的建设奠定扎实的基础，不断巩固和提高现有草莓产业化成果，加速长丰县现代生态草莓大发展，进一步提升长丰县草莓质量安全和品牌价值
        </span>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import EntityModeRatio from './entity-mode-ratio.vue'
import CertificationZone from './certification-zone.vue'
import CertificationScroller from './certification-scroller.vue'
import InputsZone from './inputs-zone.vue'
export default {
  components: {
    EntityModeRatio,
    CertificationScroller,
    CertificationZone,
    InputsZone,
  },
  data() {
    return {}
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen28896/administration-zone/index.vue